module.exports = __webpack_public_path__ + "img/ibbilInsuranceLogo.c0151d15.png";